import React from 'react';
import useWidgetDetail from '../../hooks/widget/useWidgetDetail';
import WidgetForm from '../../views/widget/detail/WidgetForm';
import useWidgetEdit from '../../hooks/widget/useWidgetEdit';
import useWidgetId from '../../hooks/widget/useWidgetId';
import FullPageSpinner from '../../components/spinner/FullPageSpinner';
import PageTemplate from '../../components/template/PageTemplate';
import { WIDGET_PAGE_NAME } from '../../constants/service/app/widgetConstants';
import useRedirect from '../../hooks/common/useRedirect';
import { WIDGET_ALL_LIST_URL_PATH } from '../../constants/service/common/urlConstants';
import usePrompt from '../../hooks/common/usePrompt';

const WidgetEdit = () => {
  const widgetId = useWidgetId();
  const redirect = useRedirect();
  const {
    data,
    isLoading: isDetailLoading,
    isSuccess: isDetailSuccess,
    isError: isDetailError,
  } = useWidgetDetail(widgetId);
  const { editWidget, isSuccess, isLoading } = useWidgetEdit(widgetId);

  usePrompt(!(isSuccess || isLoading), '편집을 중단하시겠습니까?');

  if (isDetailLoading) return <FullPageSpinner />;

  if (isDetailError) {
    redirect(WIDGET_ALL_LIST_URL_PATH);
    return null;
  }

  if (isDetailSuccess)
    return (
      <PageTemplate pageName={WIDGET_PAGE_NAME.WIDGET_EDIT}>
        <WidgetForm key={widgetId} onFinish={editWidget} initialValue={data} isEdit={true} />
      </PageTemplate>
    );
};

export default WidgetEdit;
